import { Button } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'
import { DownloadApp } from './Icons'
import ModalContainer from './Modal/ModalContainer'
import { clickOnDownload, modalOpeningTracking, setTimeToDisplayAgain } from './BannerBehaviour'
import { DragAndDrop } from '../DragAndDrop'

type BannerComponentProps = {
  isOnMobileApp: boolean
  displayComponent: boolean
  datePromotion: string
  environment: string
  textFirstLine: string
  textSecondLine: string
  textButton: string
  linkButton: string
}

const BannerComponent = ({
  isOnMobileApp,
  datePromotion,
  displayComponent,
  environment,
  textFirstLine,
  textSecondLine,
  textButton,
  linkButton
}: BannerComponentProps) => {
  const firstLineContent = isOnMobileApp ? 'Saiba como ganhar ' : textFirstLine
  const secondLineContent = isOnMobileApp ? 'R$ 10 de desconto' : textSecondLine
  const buttonContent = isOnMobileApp ? 'Saber mais' : textButton

  const { openModal } = ModalContainer({ datePromotion, environment })
  const contextFunction = isOnMobileApp
    ? () => {
        modalOpeningTracking()
        openModal()
      }
    : clickOnDownload.bind(this, linkButton)

  return (
    <DragAndDrop displayComponent={displayComponent} onClose={setTimeToDisplayAgain}>
      <S.Wrapper>
        <S.WrapperIcon>
          <DownloadApp />
        </S.WrapperIcon>
        <S.WrapperText>
          <S.WrapperFirstLine>{firstLineContent}</S.WrapperFirstLine>
          <S.WrapperSecondLine>{secondLineContent}</S.WrapperSecondLine>
        </S.WrapperText>
        <S.WrapperButton>
          <Button onClick={(e) => contextFunction(e)}>
            {buttonContent}
          </Button>
        </S.WrapperButton>
      </S.Wrapper>
    </DragAndDrop>
  )
}

export default BannerComponent
